<template>
    <div class="condition-content">
        <compare-selector
            ref="selector"
            :value="currentValue"
            :multiple="true"
            :options="options"
            select-type="tree"
            :tag-formatter="tagFormatter"
            :placeholder="$t('请选择客户标签')"
            :valid="valid"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareSelector from './plugins/compare-selector';
import { selectValidator } from './validate';

const optionMap = {};
export default {
  name: 'CustomerTag',

  components: {
    CompareSelector,
  },

  props: {
    value: {
      type: [Array, Object],
      default() {
        return {};
      },
    },

    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    const currentValue = this.value ? this.value || this.value.value || [] : [];
    return {
      currentValue,
      options: this.convertOptions(this.dataSource),
      treeSelect: [],
      valid: true,
      selectText: '',
    };
  },

  computed: {
    brief() {
      if (this.selectText) {
        return this.$t('客户标签为{value}', { value: this.selectText });
      }
      return undefined;

      //  })

      // const selectText = this.$refs.selector.currentOptions
      //     .filter(obj => {
      //         return this.currentValue.indexOf(obj.value) > -1;
      //     })
      //     .map(item => item.text)
      //     .join(',');

      //     console.log('标签'+selectText);

      // return `客户标签为${selectText}`;
    },
  },

  watch: {
    dataSource(newValue) {
      this.options = this.convertOptions(newValue);
    },
    value(newValue) {
      this.currentValue = newValue ? newValue || newValue.value || [] : [];
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    tagFormatter(tree) {
      if (!tree) {
        return '';
      }
      if (this.selectText) {
        return this.selectText;
      }
      return this.formatter(tree);
    },
    formatter(tree) {
      if (!tree) {
        return '';
      }
      let fullString = tree
        .map((grp) => {
          let ret = grp.text;
          if (grp.children && grp.children.length > 0) {
            ret += `:${grp.children
              .map(item => item.text)
              .join('/')}`;
          }
          return ret;
        })
        .join(',');
      if (fullString.length > 40) {
        fullString = `${fullString.substr(0, 40 - 4)}${this.$t('...等')}`;
      }
      return fullString;
    },
    validate() {
      this.valid = selectValidator(this.currentValue);
      return this.valid;
    },
    onChange(value, treeSelect) {
      this.valid = true;
      this.treeSelect = treeSelect;
      this.selectText = this.formatter(treeSelect);
      this.currentValue = value;
      let onlyIds = [];
      if (value && value.length > 0) {
        value.forEach((item) => {
          if (optionMap[item]) {
            onlyIds = onlyIds.concat(optionMap[item].map(subtag => subtag.aid));
          } else {
            onlyIds.push(item);
          }
        });
      }
      const ruleValue = onlyIds.map(item => parseInt(item, 10));
      const ruleData = {
        operation: 'arrayContainsAny',
        name: 'customerTag',
        type: 'array',
        value: JSON.stringify(ruleValue),
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: selectValidator(value),
      });
    },
    convertOptions(dataSource) {
      const originOptions = dataSource ? dataSource.addonAttr : [];
      return this.generatorTree(originOptions);
    },
    generatorTree(originOptions) {
      const options = [];
      originOptions.forEach((item) => {
        if (item.sub) {
          const id = `g_${item.aid}`;
          optionMap[id] = item.sub;
          options.push({
            text: item.name,
            value: id,
            children: this.generatorTree(item.sub),
          });
        } else {
          options.push({
            text: item.name,
            value: item.aid,
          });
        }
      });
      return options;
    },
  },
};
</script>
